import { render } from "./AdminServices.vue?vue&type=template&id=7ce62e93"
import script from "./AdminServices.vue?vue&type=script&lang=js"
export * from "./AdminServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__